var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComputingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9593 30.3337H11.9593C4.71931 30.3337 1.62598 27.2403 1.62598 20.0003V12.0003C1.62598 4.76033 4.71931 1.66699 11.9593 1.66699H19.9593C27.1993 1.66699 30.2926 4.76033 30.2926 12.0003V20.0003C30.2926 27.2403 27.2126 30.3337 19.9593 30.3337ZM11.9593 3.66699C5.81264 3.66699 3.62598 5.85366 3.62598 12.0003V20.0003C3.62598 26.147 5.81264 28.3337 11.9593 28.3337H19.9593C26.106 28.3337 28.2926 26.147 28.2926 20.0003V12.0003C28.2926 5.85366 26.106 3.66699 19.9593 3.66699H11.9593Z",
    fill: "#286FB7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.35995 27.2669C4.10661 27.2669 3.85328 27.1736 3.65328 26.9736C3.26661 26.5869 3.26661 25.9469 3.65328 25.5602L25.5866 3.62691C25.9733 3.24025 26.6133 3.24025 27 3.62691C27.3866 4.01358 27.3866 4.65358 27 5.04025L5.06661 26.9736C4.87995 27.1736 4.62661 27.2669 4.35995 27.2669Z",
    fill: "#286FB7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4131 24.9997C20.8664 24.9997 20.4131 24.5463 20.4131 23.9997V17.333C20.4131 16.7863 20.8664 16.333 21.4131 16.333C21.9598 16.333 22.4131 16.7863 22.4131 17.333V23.9997C22.4131 24.5463 21.9598 24.9997 21.4131 24.9997Z",
    fill: "#286FB7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6667 21.667H18C17.4533 21.667 17 21.2137 17 20.667C17 20.1203 17.4533 19.667 18 19.667H24.6667C25.2133 19.667 25.6667 20.1203 25.6667 20.667C25.6667 21.2137 25.2133 21.667 24.6667 21.667Z",
    fill: "#286FB7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9997 11H7.33301C6.78634 11 6.33301 10.5467 6.33301 10C6.33301 9.45333 6.78634 9 7.33301 9H13.9997C14.5463 9 14.9997 9.45333 14.9997 10C14.9997 10.5467 14.5463 11 13.9997 11Z",
    fill: "#286FB7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputingIcon);
export default __webpack_public_path__ + "static/media/ComputingIcon.c539ab43eb94dce22f38e598ca6dd0b2.svg";
export { ForwardRef as ReactComponent };